<template>
  <!-- Coupon -->
  <v-card
    class="coupon d-flex flex-column flex-grow-1 fill-height transparent"
    flat
    tile
    :style="{
      'padding-top': $vuetify.breakpoint.smAndDown ? '48px' : '64px',
    }"
  >
    <v-toolbar
      absolute
      width="100%"
      elevation="3"
      :dense="this.$vuetify.breakpoint.mdAndDown"
      :color="
        odds_selecteds.length
          ? 'primary darken-1'
          : 'colorDominant colorAppBar lighten-1'
      "
      :dark="odds_selecteds.length >= 1"
    >
      <v-toolbar-title class="subtitle-1">{{
        odds_selecteds.length
          ? `${odds_selecteds.length} ${$t("selection")}`
          : $t("ticket")
      }}</v-toolbar-title>

      <div class="flex-grow-1"></div>

      <v-scale-transition>
        <v-btn
          v-if="odds_selecteds.length >= 1"
          icon
          v-on:click="cleanCoupon()"
        >
          <v-icon dark>mdi-delete-outline</v-icon>
        </v-btn>
      </v-scale-transition>

      <v-btn
        icon
        v-on:click="expandCoupon"
        v-if="this.$vuetify.breakpoint.xlOnly"
      >
        <v-icon v-if="showExpand">mdi-unfold-less-vertical</v-icon>
        <v-icon v-else>mdi-unfold-more-vertical</v-icon>
      </v-btn>
    </v-toolbar>

    <div
      class="d-flex flex-grow-1 flex-column"
      :style="{
        height: $vuetify.breakpoint.smAndDown
          ? 'calc(100% - 48px)'
          : 'calc(100% - 64px)',
      }"
    >
      <!-- List Coupom -->
      <!-- livematchpro  -->

      <!-- <div>
        <section>
          Live pro match
        </section>
        <section
          id="Tracker-1"
          class="STATSCORE__Tracker"
          data-event="7390768"
          data-lang="en"
          data-config="1302"
          data-zone=""
          data-use-mapped-id="1"
        ></section>
       
      </div> -->
      <div
        style="overflow-y: auto; padding: 1px 1px 0 0"
        class="group-coupon pb-0 flex-grow-1 colorDominant darken-3"
      >
        <template v-if="odds_selecteds.length == 0">
          <div
            class="
              py-6
              text-center
              d-flex
              flex-grow-1
              justify-center
              align-center
            "
            style="height: 100%"
          >
            <div
              style="width: 100%"
              class="grey--text fill-height justify-center d-flex flex-column"
            >
              {{ $t("no_selection") }}
            </div>
            <!-- <v-icon color>mdi-emoticon-neutral-outline</v-icon> -->
          </div>
        </template>
        <template v-if="odds_selecteds.length > 0">
          <!-- <v-scale-transition group> -->
          <template v-for="(item, index) in this.odds_selecteds">
            <v-card
              :id="item.data.id_odd"
              :key="`${index}-${item.data.id_odd}`"
              class="item-coupon"
              light
              style="margin-bottom: 1px; border-radius: 0px"
            >
              <!-- <pre>{{ item.data }}</pre> -->
              <div class="d-flex flex-nowrap body-2">
                <div
                  class="
                    d-flex
                    flex-column flex-grow-1 flex-wrap
                    align-self-start
                    pa-3
                  "
                >
                  <div class="font-weight-bold">
                    {{ result(item.data.id_outcome || item.data.id_type) }}
                  </div>
                  <div class="caption">{{ market(item.data.id_market) }}</div>
                  <div class="caption">{{ item.description }}</div>
                </div>

                <div
                  class="
                    d-flex
                    flex-column flex-grow-0
                    pl-1
                    py-3
                    pr-2
                    text-right
                  "
                >
                  <span
                    :class="'old-value-' + item.data.id_odd"
                    style="text-decoration: line-through; font-size: 10px"
                  >
                    {{ item.old_odd }}
                  </span>
                  <div
                    class="text-no-wrap font-weight-bold align-self-baseline"
                  >
                    {{
                      item.data.odd_price_margin
                        ? item.data.odd_price_margin
                        : Number(item.data.odd_price).toFixed(2)
                    }}
                  </div>
                </div>

                <div class="d-flex">
                  <v-divider vertical></v-divider>
                  <v-btn
                    icon
                    class="mt-1 mr-1"
                    v-on:click="removeOddCoupon(item)"
                  >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </template>
        </template>
      </div>

      <!-- Footer de configurações da aposta -->
      <v-card tile class="flex-grow-0 flex-shrink-0 colorDominant">
        <v-form lazy-validation v-on:submit.prevent>
          <v-divider></v-divider>

          <div v-if="!logged.status || $isAgent()" class="pt-1">
            <!-- <v-divider v-if="$vuetify.breakpoint.smAndUp"></v-divider>             -->
            <OddsChangesSettings
              v-if="logged.status && $isAgent()"
              v-on:acceptOddsChangesUpdated="acceptOddsChangesUpdated"
            />

            <v-alert
              v-if="showPhone && !$isAgent()"
              color="warning"
              border="left"
              dense
              transition="fade-transition"
              dismissible
              class="mx-2 mb-0"
              style="font-size: 12px"
            >
              {{ $t("textPhonePreBet") }}
            </v-alert>

            <div class="d-flex subtitle-2 px-2 pt-1">
              <!-- <div v-if="showPhone" class="flex-grow-1 pr-1 pt-4">
                {{ $t("phone") }}
              </div>
              <div v-else class="flex-grow-1 pr-1 pt-1">
                {{ $t("phoneOrName") }}
              </div> -->

              <div class="flex-grow-1">
                <!-- IF TELEFONE -->
                <v-text-field
                  v-if="showPhone"
                  v-model="phone"
                  type="tel"
                  solo-inverted
                  hide-details
                  class="grey--text py-0"
                  clearable
                  placeholder="(00) 9 0000-0000"
                  :label="$t('phone')"
                  tabindex="1"
                  v-mask="'(##) # ####-####'"
                ></v-text-field>
                <!-- ELSE TELEFONE OU NOME -->
                <v-text-field
                  v-if="!$isAgent()"
                  v-model="nameOrPhonePreBet"
                  solo-inverted
                  hide-details
                  class="grey--text"
                  clearable
                  :placeholder="$t('phoneOrName')"
                  tabindex="1"
                  dense
                ></v-text-field>
                <!-- Input Agent - Register Customers -->
                <v-combobox
                  v-else-if="$isAgent() && !showPhone"
                  v-model="nameOrPhone"
                  :loading="loading"
                  :items="fillAutocomplete"
                  cache-items
                  hide-no-data
                  item-text="name"
                  return-object
                  solo-inverted
                  hide-details
                  class="grey--text mt-1"
                  clearable
                  :placeholder="$t('phoneOrName')"
                  tabindex="1"
                  dense
                ></v-combobox>
              </div>
            </div>
          </div>

          <!-- Componente Mudança de cotações de ODD -->
          <OddsChangesSettings
            v-if="logged.status && !$isAgent()"
            v-on:acceptOddsChangesUpdated="acceptOddsChangesUpdated"
          />
          <!-- Valor/Apostar com Bônus + input do valor da aposta -->

          <!-- INPUT ATUAL NA DEV -->
          <!-- <div class="d-flex px-2 pt-2 align-center subtitle-2">
            <div
              class="flex-grow-1 pr-1"
              v-if="isBonus && !$isAgent() && logged.status"
            >
              {{ $t("betBonus") }}
            </div>
            <div class="flex-grow-1 pr-1" v-else>
              {{ $t("value") }}
            </div>
            <div
              style="max-width: 180px"
              class="pl-1 flex-grow-0 flex-shrink-0"
            >
              <v-text-field
                v-model="bet_amount"
                type="number"
                label="00.00"
                :prefix="$t('labelCurrency')"
                hide-details
                solo-inverted
                class="grey--text"
                clearable
                @click.stop="valuesExpand = !valuesExpand"
                tabindex="2"
              ></v-text-field>
            </div>
          </div> -->
          <!-- INPUT ATUAL NA DEV END -->

          <!-- NOVO input valor da aposta -->
          <v-text-field
            v-model="bet_amount"
            type="number"
            placeholder="00.00"
            :prefix="`${$t('value') + ' ' + $t('labelCurrency')}`"
            style="text-align: right;"
            hide-details
            solo-inverted
            class="grey--text mx-2 my-2 inputValue"
            clearable
            dense
            @click.stop="valuesExpand = !valuesExpand"
            tabindex="2"
          ></v-text-field>

          <!-- Div dos valores pré-definidos para aposta Agente/Usuário Final -->
          <template v-if="$vuetify.breakpoint.smAndUp">
            <v-expand-transition>
              <div v-show="valuesExpand" class="px-2 mt-1 pb-2">
                <v-btn-toggle class="flex-grow-1 d-flex flex-wrap">
                  <v-btn
                    v-for="(item, index) in values"
                    :key="`${item}-${index}`"
                    v-on:click="bet_amount = item"
                    class="px-6 py-4 flex-grow-1"
                    min-width="20"
                    small
                    >{{ item }}</v-btn
                  >
                  <v-btn small v-on:click="bet_amount = ''" class="py-4 px-0">
                    <v-icon class="body-1">mdi-backspace</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    @click.stop="valuesExpand = !valuesExpand"
                    class="py-4 px-0"
                  >
                    <v-icon class="body-1">mdi-close</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-expand-transition>
          </template>
          <!-- Div dos valores pré-definidos para aposta Agente/Usuário Final END -->

          <!-- 'Usar Bônus' -->
          <div class="px-2 pt-2 pb-1 subtitle-2 mt-1 mb-1">
            <div
              class="d-flex justify-space-between"
              v-if="
                cashBonus.value >= minBetValue &&
                  cashBonus.status == 1 &&
                  !$isAgent() &&
                  logged.status
              "
            >
              <div class="ml-1 mb-3">
                {{ $t("useBonus") }}
                <span v-if="isBonus" class="green--text"
                  >({{ $t("labelCurrency")
                  }}{{ (cashBonus.value - bet_amount).toFixed(2) }})</span
                >
                <span v-else class="grey--text"
                  >({{ $t("labelCurrency")
                  }}{{ Number(cashBonus.value) }})</span
                >

                <!-- <span
                  x-small
                  :class="isBonus ? 'green--text' : ''"
                  class="ml-1"
                  v-if="isBonus"
                >
                  {{ cashBonus.value }}
                </span> -->
              </div>
              <!-- checkbox bonus -->
              <div>
                <v-icon
                  class="mr-3"
                  :key="`icon-${isBonus}`"
                  :color="isBonus ? 'success' : ''"
                  @click="isBonus = !isBonus"
                  v-text="
                    isBonus
                      ? 'mdi-checkbox-marked'
                      : 'mdi-checkbox-blank-outline'
                  "
                ></v-icon>
              </div>
            </div>

            <div class="d-flex justify-space-between mb-2">
              <div class="ml-1">Total Odds</div>
              <div class="mr-2">{{ valueTotalOdds || "00.00" }}</div>
            </div>
            <div class="d-flex justify-space-between" v-if="bet_amount != ''">
              <div class="ml-1">
                {{ $t("possibleGain") }}
              </div>
              <div class="mr-2">
                {{ $t("labelCurrency") }} {{ possible_gain }}
              </div>
            </div>
          </div>

          <v-divider></v-divider>

          <div class="pa-2">
            <v-alert
              :value="block"
              color="red"
              border="left"
              dense
              class="mb-2"
              style="font-size: 12px"
              transition="fade-transition"
              >{{ alert }}
            </v-alert>
            <v-alert
              :value="bonusBlock"
              color="red"
              border="left"
              dense
              class="mb-2"
              style="font-size: 12px"
              transition="fade-transition"
              >{{ alertBonus }}</v-alert
            >

            <v-btn
              v-if="accept_update"
              color="info"
              block
              large
              v-on:click="acceptUpdate"
            >
              {{ $t("acceptChanges") }}
            </v-btn>
            <!-- Registrar nome de jogadores -->
            <!-- Verificar o crédito do agente que terá este botão -->
            <!-- <div v-if="$isAgent()">
              <DialogRegisterPlayerName />
            </div> -->

            <v-btn
              :loading="loading"
              v-if="!accept_update"
              color="primary darken-1"
              block
              large
              type="submit"
              @click="toBet"
              :disabled="
                odds_selecteds.length == 0 ||
                  ($isCreditOnline() &&
                    !$isAgent() &&
                    $store.state.cash < minBetValue &&
                    cashBonus.value < minBetValue &&
                    logged.status) ||
                  BtnSubimmtBet ||
                  bonusBlock ||
                  (!logged.status && !nameOrPhonePreBet)
              "
              tabindex="3"
            >
              {{ $isAgent() ? this.$t("bet") : titleButton(logged.status) }}
              &nbsp;
              <span v-show="bet_amount"
                >{{ $t("labelCurrency") }}{{ bet_amount }}</span
              >
            </v-btn>
            <v-btn
              block
              class="mt-2"
              color="green"
              @click="showDialogDeposit()"
              v-if="
                $isCreditOnline() &&
                  $store.state.cash <= 0 &&
                  logged.status &&
                  !$isAgent()
              "
            >
              <v-icon left size="24">mdi-cash</v-icon>
              {{ $t("deposit") }}
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </div>
    <!-- <Feedback :data="dialog" /> -->
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { VMoney } from "v-money";
// import Feedback from '@/components/feedback/feedback'

// Components - ./components
// import TotalOdds from "./components/input-total-odds.vue";
import sendBet from "./mixins/mixin_sendBet";
import rulesCupom from "./mixins/mixin_rules_cupom";
// import DialogRegisterPlayerName from '@/components/agent/DialogRegisterPlayerName.vue'
import OddsChangesSettings from "./components/oddsChangesSettings";

export default {
  name: "Coupon",
  mixins: [sendBet, rulesCupom],
  components: {
    OddsChangesSettings,
    // "total-odds": TotalOdds,
    // DialogRegisterPlayerName,
  },
  data: () => {
    return {
      //Bet with bonus
      isBonus: false,
      alert: "",
      bonusBlock: false,
      alertBonus: "",
      //Bet with bonus
      connect: false,
      odds_selecteds: [],
      drawerRight: null,
      values: ["2", "5", "10", "20", "50", "100"],
      valuesExpand: false,
      loading: false,
      name: "SGA",
      phone: "",
      nameOrPhone: "",
      nameOrPhonePreBet: "",
      showPhone: false,
      anonymous: {
        punter: "",
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
      },
      bet_amount: "",
      total_odds: 1,
      valueTotalOdds: "",
      possible_gain: "",
      showExpand: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      dialog: {
        show: false,
        msg: "",
      },
      accept_update: false,

      // Apostas a prazo
      name_player: "",
      dialogRegister: "",
      searchOrRegisterPlayer: null,
      isLoading: false,
      fillAutocomplete: [],
      search: null,
      pre_bet: "",
      accept_odds_changes: "none",
    };
  },
  computed: {
    ...mapState(["coupons", "logged", "operators", "cashBonus"]),
    minBetValue() {
      return parseFloat(this.$store.state.operators.min_stake);
    },
  },
  watch: {
    coupons(val) {
      this.odds_selecteds = val;
      this.updateTotalOdds();
    },

    bet_amount: function(val) {
      // Validação de Aposta Bônus
      this.checkBonusRules();

      // Submeter Aposta
      this.$store.commit("setLastBetAmount", val);
      this.possibleGain();
    },
    // Escuta se é aposta é bônus
    isBonus() {
      this.checkBonusRules();
    },
  },
  mounted() {
    this.pre_bet = this.$store.state.operators.pre_bet;
    this.odds_selecteds = this.$store.getters.getCoupons;
    this.updateTotalOdds();
    this.showPhone = this.operators.pre_sms == 1 ? true : false;
    const phone = sessionStorage.getItem("punter");
    if (phone) {
      this.phone = phone;
    }
    this.listClientsAgents();
  },

  methods: {
    acceptOddsChangesUpdated(value) {
      this.accept_odds_changes = value;
    },
    titleButton: function(status) {
      const cash = this.$store.state.cash;
      if (status) {
        if (cash > 0) {
          return this.$t("bet");
        } else if (
          this.cashBonus.value >= this.minBetValue &&
          this.cashBonus.status == 1
        ) {
          // this.isBonus = true;
          return this.$t("bet");
        } else if (this.$isCreditOnline()) {
          return this.$t("depositToBet");
        } else {
          return this.pre_bet == "0" ? this.$t("bet") : this.$t("preBet");
        }
      } else {
        return this.pre_bet == "0" ? this.$t("bet") : this.$t("preBet");
      }
    },
    // Lista Jogadores do Agente registrados para apostas a prazo
    // mo autocomplete

    // Armazenar nome do Cliente

    showDialogDeposit() {
      // Close Right Bar in Mobile
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit("close");
      }
      // Open Dialog Deposit
      this.$store.commit("dialogDeposit", true);
    },

    toBet: function() {
      // Chamada para o registro, quando a banca é crédito 2
      // user deslogado e sem pre-aposta.
      if (
        this.$isCreditOnline() &&
        !this.logged.status &&
        this.pre_bet == "0"
      ) {
        this.$store.commit("showDialogRegister", true);
        return;
      }

      this.loading = true;

      let hasLiveEvent = false;

      for (let event of this.coupons) {
        if (event.live) {
          hasLiveEvent = true;
        }
      }

      if (hasLiveEvent === false) {
        this.startBetRequest();
      } else {
        setTimeout(() => {
          this.startBetRequest();
        }, 3000);
      }
    },

    startBetRequest() {
      if (!this.$store.state.logged.status) {
        const url =
          this.operators.pre_sms == 1
            ? "/player/bets/betAnonymous"
            : "/player/bets/betAnonymousNoSms";
        this.initSendBet(url);
      }

      // Check User Credit Online e User is Logged
      else if (
        this.$isCreditOnline() &&
        this.$store.state.logged.status &&
        !this.isBonus
      ) {
        const url = "/player/online/betsOnline/placebet";
        this.initSendBet(url);
      }
      // Use when user chose bet with bonus
      else if (
        this.$isCreditOnline() &&
        this.isBonus &&
        this.cashBonus.value >= this.minBetValue &&
        this.cashBonus.status == 1
      ) {
        const url = "/player/bonus/betsOnline/placebet";
        this.initSendBet(url);
      } else {
        const url =
          this.$store.state.logged.status && this.$store.state.cash == 0
            ? "/player/bets/preBet"
            : "/player/bets/placebet";
        this.initSendBet(url);
      }
    },

    // Remove Odd Coupon
    removeOddCoupon: function(odd) {
      // Register event remove_from_cart;
      this.$gtag.remove_from_cart(odd);

      // remove odd cart
      this.odds_selecteds = this.odds_selecteds.filter(
        (item) => item.id_event !== odd.id_event
      );
      this.$store.commit("setCoupons", this.odds_selecteds);
    },

    // Clear Coupon
    cleanCoupon: function() {
      // Register event remove_from_cart;
      this.coupons.forEach((odd) => {
        this.$gtag.remove_from_cart(odd);
      });

      // Clean Coupon
      this.$store.commit("setCoupons", []);
      this.bet_amount = "";
    },

    market: function(val) {
      if (val !== undefined)
        return this.$store.getters.getMarkets.filter(
          (item) => item.id_market == val
        )[0].name_market;
    },

    result: function(val) {
      if (val !== undefined)
        return this.$store.getters.getResults.filter(
          (item) => item.id_outcome == val
        )[0].name_outcome;
    },

    updateTotalOdds: function() {
      this.total_odds = 1;
      this.valueTotalOdds = "";
      this.odds_selecteds.forEach((item) => {
        let total_odds =
          this.total_odds *
          Number(item.data.odd_price_margin || item.data.odd_price);
        this.total_odds = total_odds;
        const index = String(this.total_odds).indexOf(".");
        let valueTotalOdds =
          index != -1
            ? String(this.total_odds).slice(0, index + 3)
            : String(this.total_odds);

        if (this.$isAgent() && this.logged.status) {
          const { multi_max } = this.logged.data;
          this.valueTotalOdds =
            this.total_odds > multi_max ? multi_max : valueTotalOdds;
        } else {
          const { multi_max } = this.operators;
          this.valueTotalOdds =
            this.total_odds > multi_max ? multi_max : valueTotalOdds;
        }
      });
      this.possibleGain();
    },

    possibleGain: function() {
      const bet_amount = this.bet_amount == "" ? 1 : this.bet_amount;
      this.possible_gain = this.decimalAdjustment(
        bet_amount * this.valueTotalOdds
      );
      if (this.odds_selecteds.length == 0) {
        this.possible_gain = 0;
      }
    },
    // Quando o usuário aposta com Bônus, verifica se o valor da aposta é maior que o bônus disponível caso sim, aparece um alerta
    checkBonusRules() {
      if (this.isBonus == true) {
        this.bonusBlock =
          Number(this.bet_amount) > Number(this.cashBonus.value) ? true : false;
        this.alertBonus =
          this.bonusBlock == true ? this.$t("betGreaterthanBonus") : "";
        this.possibleGain();
      }
      if (this.isBonus == false) {
        this.bonusBlock = false;
        this.alertBonus = "";
        this.possibleGain();
      }
    },
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
    expandCoupon: function() {
      this.$emit("expand-coupon");
      this.showExpand == true
        ? (this.showExpand = false)
        : (this.showExpand = true);
    },
  },
  directives: {
    money: VMoney,
  },
};
</script>

<style>
.inputValue input {
  text-align: right;
}
</style>
